<template>
  <div class="product_tab_1 outer_tab">
    <!--收起内容-->
    <div class="pulldownbox info-container" v-show="!showQueryFilter">
      <i class="el-icon-info"></i>
      <span>查询条件</span>
      <span class="pulldownbtn" @click="pulldown"
        >展开<i class="el-icon-arrow-down"></i
      ></span>
    </div>
    <!--展开内容-->
    <div
      style="width: 100%"
      class="expandbox info-container"
      v-show="showQueryFilter"
    >
      <el-form
        class="product_filter_form"
        :model="filterForm"
        inline
        ref="filterForm"
        size="small"
        label-width="100px"
      >
        <el-form-item label="选择区域:" prop="qhdm">
          <!--县乡村 联动-->
          <el-cascader
            style="height: 40px"
            class="textInput"
            v-model="filterForm.qhdmValue"
            :options="areaOptions"
            :props="areaProps"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="主体名称:" prop="enterpriseName">
          <el-input
            class="textInput"
            v-model="filterForm.enterpriseName"
            placeholder="请输入主体名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="社会信用代码:" prop="unifiedSocialCreditCode">
          <el-input
            class="textInput"
            v-model="filterForm.unifiedSocialCreditCode"
            placeholder="请输入社会信用代码"
          ></el-input>
        </el-form-item>
        <br/>
        <el-form-item label="法人姓名" prop="contacts">
          <el-input
            class="textInput"
            v-model="filterForm.contacts"
            placeholder="请输入法人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="评选年份:" prop="year" class="small-input">
         <el-select
            v-model="filterForm.year"
            placeholder="请选择评选年份"
          >
            <el-option
              v-for="item in YearData"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="示范社等级:" prop="gradeCode">
          <el-select
            v-model="filterForm.gradeCode"
            placeholder="请选择示范社等级"
          >
            <el-option
              v-for="item in industryOptions"
              :key="item.dicNumber"
              :label="item.dicName"
              :value="item.dicNumber"
            ></el-option>
          </el-select>
        </el-form-item>
         <br/>
        <el-form-item label="审核状态:" prop="status">
          <el-select
            v-model="filterForm.status"
            placeholder="请选择审核状态"
          >
           <el-option
              v-for="item in statusList"
              :key="item.status"
              :label="item.label"
              :value="item.status"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-row style="text-align: center; margin: 5px 0">
        <el-button @click="queryBtnClick" type="primary" size="small"
          >查询</el-button
        >
        <el-button @click="resetFilter" type="primary" plain size="small"
          >重置</el-button
        >
        <span class="pullupbtn" @click="pullup"
          >收起<i class="el-icon-arrow-up"></i
        ></span>
      </el-row>
    </div>
    <div
      style="height: 100%; position: relative"
      class="tablebox info-container"
    >
      <!--总计内容-->
      <el-row class="count_content">
        <i class="el-icon-success icon-table-summary"></i>
        <span
          >共查询到
          <span class="count_number">{{ totalItems }}</span> 条数据</span
        >
        快速筛选
      </el-row>
      <div style="display: flex;">
        <div class="box_total" :class="{bg:tims==1}" @click="clicktotalItems(1)">
          <div>已认证</div>
          <div>{{successCount}}个</div>
        </div>
        <div class="box_total" :class="{bg:tims==2}" @click="clicktotalItems(2)">
          <div>待初审</div>
          <div>{{townCheckCount}}个</div>
        </div>
        <div class="box_total" :class="{bg:tims==3}" @click="clicktotalItems(3)">
          <div>待复审</div>
          <div>{{countyCheckCount	}}个</div>
        </div>
        <div class="box_total" :class="{bg:tims==4}" @click="clicktotalItems(4)">
          <div>全部</div>
          
        </div>
      </div>
      <!--table-->
      <div style="height: 100%; position: relative">
        <el-table
          class="product_tab_1_table"
          :data="tableData"
          ref="dataTable"
          @current-change="handleCurrentChange"
          height="100%"
          highlight-current-row
        >
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="qhmc"
            label="区划"
            min-width="30"
            :formatter="formatterFn"
          ></el-table-column
          ><el-table-column
            label="主体名称"
            min-width="30"
            align="center"
            prop="enterpriseName"
            :formatter="formatterFn"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="searchDialog(scope.row)" class="enterpriseNameColor">{{scope.row.enterpriseName}}</el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="unifiedSocialCreditCode"
            label="社会信用代码"
            min-width="30"
          >
          </el-table-column>
          <el-table-column
            prop="corporationName"
            label="法人姓名"
            min-width="25"
            :formatter="formatterFn"
          ></el-table-column>
          <el-table-column
            prop="corporationMobile"
            label="联系电话"
            min-width="25"
            :formatter="formatterFn"
          ></el-table-column>
          <el-table-column
            prop="gradeName"
            label="示范社等级"
            min-width="25"
            :formatter="formatterFn"
          ></el-table-column>
          <el-table-column
            prop="year"
            label="评选年份"
            min-width="25"
            :formatter="formatterFn"
          ></el-table-column>
           <el-table-column
            prop="status"
            label="审核状态"
            min-width="25"
            :formatter="formatterFn"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status==1">待初审</span>
              <span v-if="scope.row.status==2">已通过</span>
              <span v-if="scope.row.status==3">已驳回</span>
              <span v-if="scope.row.status==4">待复审</span>
              <span v-if="scope.row.status==99">取消评级</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
             min-width="30" align="center">
             <template slot-scope="scope">
               <el-tooltip class="item" content="取消评级" placement="top" v-if="scope.row.status==2">
                    <i
                      class="table-icon el-icon-refresh-right"
                     @click="refreshDialog(scope.row)"
                    ></i>
                  </el-tooltip>
               <el-tooltip class="item" content="详情" placement="top">
                    <i
                      class="table-icon el-icon-document"
                     @click="searchDialog(scope.row)"
                    ></i>
                  </el-tooltip>
                 
             </template>
            </el-table-column>
        </el-table>
      </div>
      <!--分页工具-->
      <el-row class="page-row">
        <el-pagination
          background
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="currentChange"
          layout="prev, pager, next, jumper"
          :total="totalItems"
        >
        </el-pagination>
      </el-row>
    </div>
    <detail-dialog
      :ifAudit="false"
      :ifRejected="false"
      @tableRefresh="priseList"
      ref="show_operator_dialog"
    ></detail-dialog>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import detailDialog from "./detailDialog";
import API from "@/api/serviceOrgManagement/api_userManagement";

export default {
  components: {
    detailDialog,
  },
  name: "contract-list",
  data() {
    return {
      //区域参数
      areaOptions: [],
      tims:4,
      areaProps: {
        label: "qhmc",
        value: "qhdm",
        children: "children",
        checkStrictly: true,
      },
      industryProps: {
        label: "name",
        status: "number",
      },
      statusList:[
          {
          label:'待初审',
          status:1
        },
         {
          label:'已通过',
          status:2
        },
         {
          label:'已驳回',
          value:3
        },
         {
          label:'待复审',
          status:4
        },
        {
          label:'复审通过',
          status:5
        },
        {
          label:'取消评级',
          status:'99'
        },

      ],
      filterForm: {
        qhdmValue: [Cookies.get("curAreaCode")], // 区域
        enterpriseName: "", // 主体名称
        enterpriseTypeNumber: "", // 主体类型
        unifiedSocialCreditCode: "",
        industryDicNumber: "", // 所属行业名称
        contacts: "", // 法人姓名
        submitDate: "", // 日期
        year: '',
        gradeCode: '',
         status:''//状态
      },
      submitOptions: [
        { label: "是", number: 1 },
        { label: "否", number: 0 },
      ],
      currentPage: 1 /*分页工具当前选中页*/,
      pageSize: 10,
      totalItems: 0 /*数据总条数*/,
      showQueryFilter: true /*是否显示搜索条件*/,
      currentRow: "" /*当前选中的table行*/,
      tableData: [] /*table数据源*/,
      params: {}, // 查询参数
      industryOptions: [], //主体类型列表
      industryList: [], //行业列表
      YearData:[],
      successCount:0,
      townCheckCount:0,
      countyCheckCount:0,
      roleCode:Cookies.get('roleCode')||""
    };
  },
  created() {
      let mode = this.$route.query.mode;
    if(mode=='unaudited'){
      if(this.roleCode==19){
         this.tims=3
         this.filterForm.status=4
     }else if(this.roleCode==21){
         this.tims=2
         this.filterForm.status=1
     }else{
      this.filterForm.status=""
      this.tims=4
     }
    };
    this.GLOBAL.eventBus.$on("areaOptionsCompleted", this.getNextXzqData); //
    this.GLOBAL.eventBus.$on("firstLoadAreaOption", this.getNextXzqData); //
     
  },
  beforeDestroy() {
    this.GLOBAL.eventBus.$off("areaOptionsCompleted", this.getNextXzqData); //
    this.GLOBAL.eventBus.$off("firstLoadAreaOption", this.getNextXzqData); //
  },
  mounted() {
    this.init();
    this.doHandleDate()
  },
  methods: {
    formatterFn(row, column, cellValue, index) {
      if (!cellValue) {
        return "--";
      }
      return cellValue;
    },
    formatterDate(row, column, cellValue, index) {
      if (!cellValue) {
        return "--";
      }
      return this.GLOBAL.timetoDate(Number(cellValue),'date');
    },
    /*页面初始化*/
    init() {
      this.getParams();
      this.managementTypeList();
      this.priseList();
      this.getNextXzqData();
      this.commonList();
    },
    //获取区域数据
    async getNextXzqData() {
      let regionOption = localStorage.getItem("areaOptions"); //获取乡级以上区域信息
      if (regionOption) {
        this.areaOptions = [JSON.parse(regionOption)];
      }
    },
    // 主体类型列表接口
    async commonList() {
      let { code, data } = await API.commonList({code:19});
      if (code === 0) {
        if (data && data.list && data.list.length) {
          this.industryOptions = data.list;
        }
      }
    },
    //  参数设置
    getParams() {
      let form = this.filterForm;
      this.params = {
        // 参数
        status: form.status,
        qhdm: form.qhdmValue[form.qhdmValue.length - 1],
        page: this.currentPage, 
        enterpriseName:form.enterpriseName,
        unifiedSocialCreditCode: form.unifiedSocialCreditCode,
        corporationName:form.contacts,
        year: form.year,
        gradeCode: form.gradeCode
  
      };
    },
    //列表接口
    async priseList() {
      const { code, data } = await API.demonstrationList(this.params);
      console.log("code",code)
      console.log("data",data)
      if (code === 0) {
        this.totalItems = data.count;
        this.tableData = data.list;
        this.successCount	=data.successCount
        this.townCheckCount	=data.townCheckCount
        this.countyCheckCount=data.countyCheckCount
      }
    },
    //查询所属行业接口
    async managementTypeList() {
      let { code, list } = await API.managementTypeList();
      if (code === 0) {
        this.industryList = list
      }
    },
    //设备详情
    searchDialog(row) {
      this.$refs.show_operator_dialog.dialogOpen(row);
    },
    //取消评级
    refreshDialog(row){
      this.$prompt('请输入取消评级理由', '取消评级理由', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputPattern: /\S/,
          inputErrorMessage: '取消评级理由不能为空'
        }).then(async({ value }) => {

            const {code,msg,data}=await API.demonstrationCancel({number:row.number,refuseReason:value})
            if(code==0){
                this.$message({
                    type: 'success',
                    message: msg
                  });
            }else{
              this.$message({
                  type: 'info',
                  message: msg
                });    
            }
           this.getParams()
           this.priseList()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });

    },
    /*分页工具换页*/
    currentChange(val) {
      this.currentPage = val;
      this.params.page = val;
      this.priseList();
    },

    /*点击查询按钮*/
    queryBtnClick() {
      this.currentPage = 1;
      this.getParams();
      this.priseList();
    },

    /*点击重置按钮*/
    resetFilter() {
      this.filterForm.page = this.currentPage = 1; // 页数
      this.filterForm.enterpriseName = ""; // 主体名称
      this.filterForm.unifiedSocialCreditCode = ""; //信用代码
      this.filterForm.contacts = ""; // 法人姓名
      this.filterForm.qhdmValue = [Cookies.get("curAreaCode")]; // 区域
      this.filterForm.gradeCode = ""; // 日期
      this.filterForm.year = ""; // 日期
      this.getParams();
      this.priseList();
    },
    /*table选中行回调方法*/
    handleCurrentChange(val) {
      this.currentRow = val;
    },

    /*收起按钮*/
    pullup() {
      this.showQueryFilter = false;
    },

    /*展开按钮*/
    pulldown() {
      this.showQueryFilter = true;
    },
    //主体详情
    searchDialog(row) {
      this.$refs.show_operator_dialog.dialogOpen(row);
    },
     // 点击筛选
    clicktotalItems(index){
      this.tims=index
      if(index==1){
        this.filterForm.status=2
        this.getParams()
          this.priseList()
      }else if(index==2){
        this.filterForm.status=1
        this.getParams()
          this.priseList()
      }else if(index==3){
        this.filterForm.status=4
        this.getParams()
          this.priseList()
      }else if(index==4){
         this.filterForm.status=""
         this.getParams()
          this.priseList()
      }
        // this.getParams()
        // this.priseList()
    },
    //获取年份
    doHandleDate() {
    let myDate = new Date()
     let tYear = myDate.getFullYear();
     console.log("tYear",tYear)
     for(let i=0; i<5;i++){
       this.YearData.push(tYear--) 
     }
    }
  },
};
</script>
<style lang="less">
el-dialog__header {
  background: red;
  text-align: center;
}
.enterpriseNameColor{
  color: #0EAC79;
  cursor:pointer;
  text-decoration:underline;
}
.box_total{
  height: 50px;
  border: 1px solid #EEF0F3;
  width: 23%;
  margin: 10px;
  background: #FFFFFF;
  box-shadow: 0px 0px 44px 0px rgba(118,134,182,0.1400);
  border-radius: 5px;
   display: flex;
  justify-content: space-around;
  align-items: center;
  
}
.bg{
   border: 1px solid #2A8852;
   color: #2A8852;
}
</style>




// WEBPACK FOOTER //
// src/studio/demonstration/Administration/auditedList.vue